import { render, staticRenderFns } from "./CoachDetailReviews.vue?vue&type=template&id=556dd69a&scoped=true&lang=pug"
import script from "./CoachDetailReviews.vue?vue&type=script&lang=js"
export * from "./CoachDetailReviews.vue?vue&type=script&lang=js"
import style0 from "./CoachDetailReviews.vue?vue&type=style&index=0&id=556dd69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556dd69a",
  null
  
)

export default component.exports